import { useUserContext, UserContext } from '@/contexts/userContext';
import axios, { AxiosInstance } from 'axios';
import { Region } from '@/types';

export const useAxios = (): AxiosInstance => {
    const { token, user, regions, logout } = useUserContext() as UserContext;

    const region =
        user?.region ||
        (Array.isArray(regions) ? regions.find((region: Region) => region.default)?.short_region : undefined);

    const apiUrl =
        (Array.isArray(regions) ? regions.find((r: Region) => r.short_region === region)?.api : undefined) ||
        import.meta.env.VITE_API_URL ||
        'http://localhost:3000';

    const instance = axios.create({
        baseURL: apiUrl,
        headers: {
            'Content-Type': 'application/json',
            ArchireportOrigin: 'archireportweb',
            ArchireportContext: 'AR',
            AppSession: '6.0.0',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });

    instance.interceptors.response.use(
        response => response,
        error => {
            if (error.response?.status === 401 && error.config.url !== '/login_web') {
                console.log('401 error');
                logout();
            }
            return Promise.reject(error);
        }
    );

    return instance;
};
